import { useState } from 'react'

import { NewsletterCheckbox } from '@/entities/assent'

import { formatPhoneMasked } from '@/shared/lib/validation/phone'
import { Button } from '@/shared/ui'

import { useAuthByPhoneContext } from '../auth-by-phone/auth-by-phone.context'
import { RuleCheckbox } from '../rule-checkbox/rule-checkbox'

import cl from './style.module.scss'

export const RegistrationStep = () => {
	const {
		phone,
		isLoading,
		submitError,
		showNewsletterCheckbox,
		isNewsletterAccepted,
		setIsNewsletterAccepted,
		confirmRegistration,
		goToPhone
	} = useAuthByPhoneContext()
	const [isPolicyAccepted, setIsPolicyAccepted] = useState(false)

	if (!phone) return null

	const canSubmit = isPolicyAccepted && !isLoading

	return (
		<div className={cl.root}>
			<p className={cl.title}>Регистрация</p>
			<p className={cl.phone}>Для подтверждения нужно будет позвонить с номера {formatPhoneMasked(phone)}</p>

			<div className={cl.checkboxes}>
				<RuleCheckbox checked={isPolicyAccepted} onChange={setIsPolicyAccepted} disabled={isLoading} />
				{showNewsletterCheckbox && (
					<NewsletterCheckbox checked={!!isNewsletterAccepted} onChange={setIsNewsletterAccepted} />
				)}
			</div>

			{submitError && <p className={cl.error}>{submitError}</p>}

			<Button className={cl.button} fullWidth theme="primary" onClick={confirmRegistration} disabled={!canSubmit}>
				Получить код
			</Button>

			<button type="button" className={cl.back} onClick={goToPhone} disabled={isLoading}>
				Изменить номер
			</button>
		</div>
	)
}
